import React, { useState, useEffect, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import { DatePicker } from 'react-persian-datepicker';
import moment from "moment-jalaali";
import Popup from '../../Common/Popup';
import { base_url } from '../../Api/Api';
import PulseLoader from "react-spinners/PulseLoader";
import SkltnPerson from './SkltnPersonInfo';
import { withRouter } from 'react-router';

const PersonalInfo = (props) => {

    const [loader, setLoader] = useState(false)
    const [birthday, setBirthday] = useState('')
    const [state, setState] = useState({
        data: '',
        imgPlaceholder: '',
        name: '',
        lastName: '',
        email: '',
        nationalCode: '',
        errorValid: false,
        imgUrl: '',
        textApi: '',
        popupStatus: false,
        isLoad: false
    })

    useEffect(() => {


        base_url.get(`update_profile`)
            .then(response => {
                setState({
                    ...state,
                    data: response.data,
                    imgPlaceholder: response.data.profile_photo_url,
                    name: response.data.name,
                    lastName: response.data.last_name,
                    nationalCode: response.data.national_code,
                    email: response.data.email == null ? '' : response.data.email,
                    isLoad: true
                })
                setBirthday(moment(response.data.birthdate, "jYYYY/jMM/jDD"))
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                    }
                }
            })

    }, [])

    const inputValueChange = (e, target) => {
        setState({
            ...state,
            [target]: e.currentTarget.value
        })
    }

    const handleSelect = (date) => {
        setBirthday(date)
    }

    const calendarStyles = {
        calendarContainer: 'calendarContainer editinfo-datapicker',
        dayPickerContainer: 'dayPickerContainer',
        monthsList: 'monthsList',
        daysOfWeek: 'daysOfWeek',
        dayWrapper: 'dayWrapper',
        selected: 'selected',
        heading: 'heading',
        placeholder: "تاریخ"
    }

    const validationEmail = (value) => {
        var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i)
        return !pattern.test(value)
    }

    const toggleImageFile = (event, type) => {
        setState({
            ...state,
            imgUrl: type == 'delete' ? '' : URL.createObjectURL(event.target.files[0])
        })
    };

    const submitForm = () => {

        if (state.name.length >= 3 &&
            state.lastName.length >= 3 &&
            state.nationalCode.length == 10 &&
            birthday.length !== 0 &&
            !validationEmail(state.email) &&
            !loader) {

            setLoader(true)

            let data = {
                'name': state.name,
                'last_name': state.lastName,
                'national_code': state.nationalCode,
                'birthdate': moment(birthday).format('jYYYY/jMM/jDD'),
                'email': state.email,
            }

            base_url.post(`update_profile`, data)
                .then(response => {
                    setLoader(false)
                    if (response.data.success == 1) {
                        if (state.imgUrl.length == 0) {
                            setState({
                                ...state,
                                textApi: 'اطلاعات شما با موفقیت بروزرسانی شد.',
                                popupStatus: true,
                            })
                        } else {
                            imageUpload()
                        }
                    } else {
                        setState({
                            ...state,
                            textApi: 'مشکلی بوجود آمد لطفا دوباره سعی نکنید.',
                            popupStatus: true,
                        })
                    }
                })
                .catch(error => {
                    if (error.response != undefined) {
                        if (error.response.status == 401) {
                            props.history.push(`/Entrance`)
                        } else {
                            setState({
                                ...state,
                                textApi: 'مشکلی در سرور رخ داده است لطفا بعداز چند دقیقه دوباره سعی کنید',
                                popupStatus: true,
                                popupType: 2,
                            })
                            setLoader(false)
                        }
                    }
                })

        } else {
            setState({
                ...state,
                errorValid: true
            })
        }
    }

    const imageUpload = () => {
        
        var data = new FormData(document.getElementById("formImage"));
        base_url.post(`update_profile_photo`, data)
            .then(response => {
                setState({
                    ...state,
                    textApi: 'اطلاعات شما با موفقیت بروزرسانی شد.',
                    popupStatus: true,
                    popupType: 1
                })
                setLoader(false)
            })
            .catch(error => {
                if (error.response != undefined) {
                    if (error.response.status == 401) {
                        props.history.push(`/Entrance`)
                        localStorage.clear()
                        window.location.reload()
                    } else {
                        setState({
                            ...state,
                            textApi: 'مشکلی در سرور رخ داده است لطفا بعداز چند دقیقه دوباره سعی کنید',
                            popupStatus: true,
                            popupType: 2
                        })
                        setLoader(false)
                    }
                }
            })
    }

    const popupHandle = () => {
        setState({
            ...state,
            popupStatus: !state.popupStatus
        })
        props.history.push('/profile')
        setTimeout(() => {
            window.location.reload()
        }, 200);
    }

    return (
        <Fragment>
            {!state.isLoad ?
                <SkltnPerson />
                :
                <Fragment>
                    <Popup
                        class="api-popup"
                        active={state.popupStatus}>
                        <span className="popup-tilte-edited">{state.textApi}</span>
                        <Button
                            variant="contained"
                            onClick={popupHandle} >تایید</Button>
                    </Popup>
                    <div className="InfoTitle">
                        <span>اطلاعات شخصی</span>
                    </div>
                    <div className="personalInfo">
                        <div className="profilePic">
                            <img
                                id="output"
                                src={state.imgUrl}
                                onError={(e) => e.currentTarget.src = state.imgPlaceholder} />
                            <Dropdown>
                                <Button variant="contained">
                                    <Dropdown.Toggle id="dropdown-basic">
                                        <i className="icon-photo-camera"></i>
                                    </Dropdown.Toggle>
                                </Button>
                                <Dropdown.Menu>
                                    <span className="dropdown-ttl">تغییر عکس پروفایل</span>
                                    <Button className="dropdownBtn btn-first" variant="contained">
                                        <form className="input-select" id="formImage">
                                            <input
                                                type="file"
                                                accept="image/*"
                                                name="photo"
                                                id="file"
                                                onChange={(event) => toggleImageFile(event)} />
                                        </form>
                        انتخاب عکس
                    </Button>
                                    {state.imgUrl.length == 0 ? null :
                                        <Button
                                            className="dropdownBtn btn-second"
                                            variant="contained"
                                            onClick={(event) => toggleImageFile(event, 'delete')} >
                                            حذف عکس
                        </Button>
                                    }
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <div className="form">
                            <div className="inputs-form">
                                <div className="input-form">
                                    <TextField
                                        label="نام"
                                        type="text"
                                        onChange={(e) => inputValueChange(e, 'name')}
                                        value={state.name}
                                    />
                                    <span className={`error-respns ${(state.name.trim().length < 3 && state.errorValid) ? 'active' : ''}`}>
                                        <i className="icon-exclamation-mark"></i>
                        نام خانوادگی خود را کامل وارد کنید
                    </span>
                                </div>
                                <div className="input-form">
                                    <TextField
                                        label="نام خانوادگی"
                                        type="text"
                                        onChange={(e) => inputValueChange(e, 'lastName')}
                                        value={state.lastName}
                                    />
                                    <span className={`error-respns ${(state.lastName.trim().length < 3 && state.errorValid) ? 'active' : ''}`}>
                                        <i className="icon-exclamation-mark"></i>
                        نام خانوادگی خود را کامل وارد کنید
                    </span>
                                </div>
                                <div className="input-form">
                                    <TextField
                                        label="ایمیل"
                                        type="text"
                                        onChange={(e) => inputValueChange(e, 'email')}
                                        value={state.email}
                                    />
                                    <span className={`error-respns ${(validationEmail(state.email) && state.errorValid) ? 'active' : ''}`}>
                                        <i className="icon-exclamation-mark"></i>
                        نام خانوادگی خود را کامل وارد کنید
                    </span>
                                </div>
                                <div className="input-form">
                                    <TextField
                                        label="کد ملی"
                                        type="text"
                                        onChange={(e) => inputValueChange(e, 'nationalCode')}
                                        onPaste={(e) => e.preventDefault()}
                                        onInput={(e) => {
                                            if (!(/^\d+$/).test(e.target.value)) {
                                                e.target.value = e.target.value.slice(0, e.target.value.length - 1)
                                            }
                                            e.target.value = e.target.value.slice(0, 10)
                                        }}
                                        value={state.nationalCode}
                                    />
                                    <span className={`error-respns ${(state.nationalCode.trim().length !== 10 && state.errorValid) ? 'active' : ''}`}>
                                        <i className="icon-exclamation-mark"></i>
                                        نام خانوادگی خود را کامل وارد کنید
                                    </span>
                                </div>
                                <div className="input-form birthday">
                                    <span className="label-input">تاریخ تولد</span>
                                    <DatePicker
                                        inputFormat="jYYYY/jMM/jDD"
                                        onChange={(dateBirth) => handleSelect(dateBirth)}
                                        calendarStyles={calendarStyles}
                                        value={birthday}
                                        placeholder="تاریخ تولد"
                                        max={moment()} />
                                    <span className={`error-respns ${(birthday.length < 9 && state.errorValid) ? 'active' : ''}`}>
                                        <i className="icon-exclamation-mark"></i>
                        نام خانوادگی خود را کامل وارد کنید
                    </span>
                                </div>
                                <div className="btn-base btn-black btn-sircle">
                                    <Button
                                        variant="contained"
                                        onClick={submitForm} >
                                        {loader ?
                                            <PulseLoader
                                                color="#1e1e1e"
                                                loading={true}
                                                size={12} />
                                            :
                                            'ویرایش اطلاعات'
                                        }
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fragment>
            }
        </Fragment>
    );
}
export default withRouter(PersonalInfo);